import React from "react";
import { Typography } from "antd";
import OrderTableForm from "./orderManagementListing/OrderTable";
import OrderTaskFilters from "./orderManagementListing/OrderFilters";

const { Title } = Typography;
const OverviewListPage = () => {
  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>Orders Management</Title>
        </div>
        <div className="pch"></div>
      </div>
      <div className="p-content">
        <OrderTaskFilters />
        <OrderTableForm />
      </div>
    </div>
  );
};
export default OverviewListPage;
